import React from 'react';
import { Alert } from '@mui/material';

/**
 * Dismissible page-level error banner (Phase 4.1).
 * Use for initial load / page-scope failures; use ToastContext for action toasts.
 */
export default function PageErrorAlert({
  message,
  onClose,
  severity = 'error',
  sx,
}) {
  if (!message) return null;

  return (
    <Alert severity={severity} sx={{ mb: 2, ...sx }} onClose={onClose}>
      {message}
    </Alert>
  );
}
